import type { Filter_FacetsFragment } from '@generated/graphql'

export const getMaxMinAbsolutePrice = (
  facetsFormatted?: Filter_FacetsFragment[]
) => {
  const facetFind = facetsFormatted?.find(
    (facet) => facet.__typename === 'StoreFacetRange' && facet.key === 'price'
  )

  return {
    minAbsolutePrice:
      facetFind?.__typename === 'StoreFacetRange'
        ? facetFind?.min?.absolute
        : undefined,
    maxAbsolutePrice:
      facetFind?.__typename === 'StoreFacetRange'
        ? facetFind?.max?.absolute
        : undefined,
  }
}
